export const MAP_ROUTE_ACTIVE_COLOR = '#FFC719'
export const MAP_ROUTE_INACTIVE_COLOR = '#6D6B70'
